import { ConnectedProps, connect } from 'react-redux'
import { ButtonPrimaryInfoLeft } from '../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { BaseScreenPageData } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import TableMaterials from '../../../../../../specificComponents/Product/Tables/TableMaterials'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { CategoriesPayload } from '../../../../../../utils/reducers/products/categories'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import ModalCreateMaterialConnect from './ModalCreateMaterial'
import ModalDeleteMaterial from './ModalDeleteMaterial'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'

type MaterialsProps = ComponentWithPermissions & ReduxMaterials & { }

const Materials: React.FC<MaterialsProps> = ({ userPermissions, ...button }) => {
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('materials', 'Materiales'),
        newText: t('newMaterial', 'Nuevo material'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableMaterialsConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateMaterialConnect} DeleteModalComponent={ModalDeleteMaterial} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderMaterialTable {...{ pageData, setOpenModal, ...button, userPermissions }} />
        }>
        </BaseScreenTableSimpleStateless>    )
}

const materialsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

type ReduxMaterials = ConnectedProps<typeof materialsConnect>
const mapMaterialsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const materialsConnect = connect(mapMaterialsConnector, materialsDispatch)

const materialsConnectLoading = withLoading(Materials, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const MaterialsConnect = materialsConnect(materialsConnectLoading)


type RightHeaderMaterialTableProps = ComponentWithPermissions & ReduxMaterials & {
    pageData: BaseScreenPageData
    setOpenModal: SetEditDeleteModalTy
}

const RightHeaderMaterialTable: React.FC<RightHeaderMaterialTableProps> = ({ pageData, userPermissions, specificPriceRules, setOpenModal }) => {
    const { t } = useTwinTranslation()
    return (
        <PermissionChecker userPermissions={userPermissions} permission='create'>
            {pageData.newText ? <ButtonPrimaryInfoLeft onClick={async () => setOpenModal({ type: 'create', allRowData: {} })} textButton={<span><TwinIcon icon={faPlus} className='mr-8' />{pageData.newText}</span>} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')} /> : null}
        </PermissionChecker>
    )
}


const categoriesDispatch = {
    setCategories: (payload: CategoriesPayload) => ({ type: 'CHANGE_CATEGORIES', payload }),
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapCategoriesConnector = (state: AllReduxPayloads) => ({ categories: state.categories, specificPriceRules: state.specificPriceRules })
const categoriesConnect = connect(mapCategoriesConnector, categoriesDispatch)

const categoriesConnectLoading = withLoading(TableMaterials, [{ fetchUrl: '/api/app/product/category/getAllCategories', propName: 'categories', setFunctionName: 'setCategories' }, { fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules'}])
const TableMaterialsConnect = categoriesConnect(categoriesConnectLoading)

export default MaterialsConnect